import 'lenis/dist/lenis.css'
import '../scss/main.scss'
import { header } from './template-parts/header/header'
import { footer } from './template-parts/footer/footer'
import { initMotion } from './motion'

header()
footer()

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initMotion)
} else {
	initMotion()
}
